/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_UsersInputs */

const cs_nav_users = /** @type {(inputs: Nav_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatelé`)
};

const en_nav_users = /** @type {(inputs: Nav_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users`)
};

/**
* | output |
* | --- |
* | "Users" |
*
* @param {Nav_UsersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_users = /** @type {((inputs?: Nav_UsersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_UsersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_users(inputs)
	return cs_nav_users(inputs)
});